import {ConditionType,} from "../../model2/conditions/condition-types"
import Filter from "../../manager/filters/manager/filter"
import {momentRange} from "../../gd/convert/moment-range";

// const debug = "FieldDaterange_filterFunc"
const debug = false


export function FieldDaterange_filterFunc(filter: Filter, model:any): boolean {

    debug && console.log(debug, "filter=", filter) // model

    // zachem hez...
    if (!filter.type) return true;  // Esli net condition type propuskaem filter


    // make sure mode has value set and it is daterange
    const fieldRange        = _.get(model, filter.field?.fieldId!, null)


    // process set-notset rules
    switch (filter.type) {
        case ConditionType.IS_NULL:
            return (!fieldRange)

        case ConditionType.NOT_NULL:
            return (!!fieldRange)

        default:
            // do nothing in here
            break
    }



    // Init Filter value
    let filterRange : MomentRange

    switch (filter.type) {
        case ConditionType.DATERANGE_FIXED_INCLUDES:
        case ConditionType.DATERANGE_FIXED_OVERLAPS:
        case ConditionType.DATERANGE_FIXED_WITHIN:
            filterRange = filter.value
            break

        case ConditionType.DATERANGE_RELATIVE_INCLUDES:
        case ConditionType.DATERANGE_RELATIVE_OVERLAPS:
        case ConditionType.DATERANGE_RELATIVE_WITHIN:
            let relativeRange = filterRange = filter.value

            filterRange = momentRange(
                moment().add(relativeRange.start, 'days'),
                moment().add(relativeRange.end, 'days')
            )
            break
        default:
            console.error('#928dj2h278298 FieldDaterange_filterFunc unknown filter type', filter.type)
            return true
    }



    // Future....
        // // Field value
    // switch (filter.type) {
    //     case ConditionType.IS_NULL:
    //         return _.isNil(fieldValue)
    //     case ConditionType.NOT_NULL:
    //         return !_.isNil(fieldValue)
    // }


    if (debug) {
        console.log('    filterDateRange=', filterRange?.start?.format('YYYY-MM-DD'), filterRange?.end?.format('YYYY-MM-DD'))
        console.log('    fieldRange=', fieldRange?.start?.format('YYYY-MM-DD'), fieldRange?.end?.format('YYYY-MM-DD'))
    }


    // Validate values
    if (!fieldRange) {
        // no value in field -> false
        return false
    }

    // jsut in case something went wrong with filter value
    if (!filterRange?.start || !filterRange?.end) {
        return true
    }

    switch (filter.type) {
        case ConditionType.DATERANGE_FIXED_INCLUDES:
        case ConditionType.DATERANGE_RELATIVE_INCLUDES:
            return fieldRange.start.isSameOrBefore(filterRange.start, 'day') && fieldRange.end.isSameOrAfter(filterRange.end, 'day')

        case ConditionType.DATERANGE_FIXED_OVERLAPS:
        case ConditionType.DATERANGE_RELATIVE_OVERLAPS:
            // return fieldRange.overlaps(filterRange, { adjacent: true });
            const overlaps = fieldRange.start.isSameOrBefore(filterRange.end, 'day') && fieldRange.end.isSameOrAfter(filterRange.start, 'day');
            return overlaps

        case ConditionType.DATERANGE_FIXED_WITHIN:
        case ConditionType.DATERANGE_RELATIVE_WITHIN:
            return filterRange.start.isSameOrBefore(fieldRange.start, 'day') && filterRange.end.isSameOrAfter(fieldRange.end, 'day')

        default:
            console.error('#928dj2h278298 FieldDaterange_filterFunc unknown filter type', filter.type)
            return true
    }

}